import {entityDocumentosFeatureKey, selectAll, selectEntities} from './entity-documento.reducer';
import {selectors} from '~utils/ngrx-util';

const {
  entitySelectAll,
  entitySelectEntities,
  entitySelectById,
} = selectors(entityDocumentosFeatureKey, {selectAll, selectEntities});

export const entityDocumentoSelectAll = entitySelectAll;
export const entityDocumentoSelectEntities = entitySelectEntities;
export const entityDocumentoSelectById = entitySelectById;
